// removed by extract-text-webpack-plugin
module.exports = {"counter":"src-components-Counter-__counter-module___counter","decrease":"src-components-Counter-__counter-module___decrease","increase":"src-components-Counter-__counter-module___increase","count":"src-components-Counter-__counter-module___count"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Counter/counter.module.css
// module id = 952
// module chunks = 0